import { ButtonBase, Tooltip } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import { DASHBOARD_COLORS } from './statusDashboardStyles';

export interface PillToggleOption<T extends string> {
  value: T;
  label: string;
  disabled?: boolean;
  tooltip?: string;
}

interface PillToggleProps<T extends string> {
  options: PillToggleOption<T>[];
  value: T;
  onChange: (value: T) => void;
}

const useStyles = makeStyles(() => ({
  group: {
    display: 'flex',
    padding: 3,
    gap: 3,
    background: DASHBOARD_COLORS.neutral100,
    borderRadius: 32,
  },
  pill: {
    padding: '0 18px',
    height: 34,
    borderRadius: 32,
    fontFamily: 'inherit',
    fontSize: 13,
    fontWeight: 700,
    color: DASHBOARD_COLORS.neutral800,
  },
  active: {
    background: DASHBOARD_COLORS.card,
    color: DASHBOARD_COLORS.foreground,
    boxShadow: '-2px 2px 4px 0 rgba(52, 57, 94, 0.10)',
  },
  disabled: {
    opacity: 0.5,
  },
}));

export const PillToggle = <T extends string>({ options, value, onChange }: PillToggleProps<T>) => {
  const classes = useStyles();
  return (
    <div className={classes.group}>
      {options.map(option => (
        <Tooltip key={option.value} title={option.tooltip ?? ''}>
          <span>
            <ButtonBase
              className={clsx(
                classes.pill,
                option.value === value && classes.active,
                option.disabled && classes.disabled
              )}
              disabled={option.disabled}
              onClick={() => onChange(option.value)}
            >
              {option.label}
            </ButtonBase>
          </span>
        </Tooltip>
      ))}
    </div>
  );
};
